import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	background-color: #f5f5f5;

	padding: 1rem;
`;

export const Content = styled.div`
	width: 100%;
	height: 100%;

	font-family: "Roboto";

	position: relative;

	.header {
		display: flex;

		align-items: flex-start;

		width: 100%;
		height: 5%;

		gap: 0.5rem;

		p {
			font-size: 1.2rem;
			font-weight: 600;
			font-family: "Mulish";
		}
	}

	#func {
		color: #252733;
	}

	#name {
		color: #2d7bbc;
	}

	.process-wrapper {
		display: flex;

		width: 100%;
		height: 100%;

		min-height: 35rem;
		max-height: 50rem;

		gap: 2.5%;
	}

	.consult-container {
		display: flex;
		flex-direction: column;

		width: 80%;
		height: 100%;

		padding: 2rem 0 0 2rem;
	}

	.process-header {
		display: flex;
		flex-direction: column;
	}

	#title {
		height: 1.5rem;

		font-size: 1.2rem;
		font-weight: 500;

		color: #4c4f6d;
	}

	.input-wrapper {
		display: flex;

		align-items: center;

		position: relative;

		margin-top: 3rem;
	}

	#search-svg {
		width: 1.5rem;
		height: 2rem;

		position: absolute;

		left: 0.5rem;

		color: #caccd9;
	}

	#searchbar {
		width: 20rem;
		height: 3rem;

		border: 1px solid #caccd9;
		border-radius: 0.25rem;

		padding-left: 2.5rem;

		font-size: 1.2rem;

		::placeholder {
			color: #caccd9;
		}
	}

	#searchbar:focus {
		color: #2d7bbc;

		border-color: #2d7bbc;

		::placeholder {
			color: #2d7bbc;
		}
	}

	hr {
		border: 1px solid #e7e7e7;

		margin-top: 1.5rem;
	}

	.table-wrapper {
		overflow: auto;
	}

	.table-wrapper {
		width: 100%;
		height: 80%;
	}

	.table-content {
		width: 100%;
		height: 100%;

		overflow: auto;
	}

	table {
		width: 100%;

		position: relative;

		padding: 0 1rem;

		border-collapse: separate;
		border-spacing: 0 8px;
	}

	tr {
		text-align: center;

		height: 5rem;
		max-height: 5rem;
	}

	th {
		color: #6870a8;
	}

	td {
		color: #a9a5bd;

		font-size: 1rem;
	}

	#table-header {
		position: sticky;

		height: 80px;
		width: 100%;

		font-weight: 500;

		top: 0;

		background-color: #f4f4f4;
	}

	.process-container {
		background-color: white;

		cursor: pointer;

		box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);

		border-bottom: 1px solid #e7e7e7;
		:hover {
			background-color: rgba(55, 21, 255, 0.1);

			td {
				color: #3751ff;
			}
		}
	}

	.get-in {
		width: 5rem;
		height: 2.5rem;

		background: none;

		color: #2d7bbc;

		font-weight: 700;

		border: 1px solid #2d7bbc;
		border-radius: 0.25rem;

		cursor: pointer;

		transition: 0.2s;
	}

	.get-in:hover {
	}

	.process-details {
		width: 25%;
		height: 95%;

		border-radius: 0.5rem;

		padding: 1rem;

		background-color: white;

		box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

		hr {
			margin-bottom: 1rem;
			box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.3);
		}
	}

	.process-prop-name {
		display: flex;
		flex-direction: column;

		height: 6rem;

		justify-content: space-evenly;

		.prop-name {
			color: #6870a8;

			font-size: 1.2rem;
			font-weight: 700;

			text-transform: capitalize;
		}

		.prop-cpf {
			font-size: 0.9rem;
			font-weight: 700;

			color: #6870a8;
		}
	}

	.process-infos {
		width: 100%;

		padding: 1rem;

		overflow: auto;
	}

	.progress-wrapper {
		width: 100%;
		margin-top: 2rem;
		margin-bottom: 5rem;
	}

	.progress-title {
		font-size: 1rem;
		font-weight: bold;

		text-transform: uppercase;
		text-align: center;

		color: #2d7bbc;

		margin-bottom: 1rem;
	}

	.progress-status {
		width: 100%;

		margin-top: 1rem;

		text-align: center;

		p {
			color: #4c4f6d;

			font-size: 1.5rem;
			font-weight: 500;
		}
	}

	.process-info-title {
		color: #4c4f6d;

		font-size: 0.8rem;

		margin-bottom: 1rem;
	}

	.process-info {
		margin-top: 1rem;

		tr {
			height: 2rem;
		}

		th {
			width: 40%;

			text-align: left;

			font-size: 0.9rem;
		}

		td,
		.analist-name {
			width: 60%;

			color: #a9a5bd;

			font-size: 0.9rem;

			text-align: end;
		}

		#get-in {
			text-transform: uppercase;

			font-weight: bold;
		}
	}

	.get-in-process {
		display: flex;

		width: 100%;
		height: 20%;

		justify-content: center;
		align-items: center;
	}

	#get-in-process {
		width: 8rem;
		height: 3rem;

		border: none;
		border-radius: 0.25rem;

		background-color: #2d7bbc;

		color: white;

		cursor: pointer;

		font-weight: 600;
		font-size: 1.2rem;
	}

	.no-process-selected {
		display: flex;
		flex-direction: column;

		width: 100%;
		height: 60%;

		justify-content: center;
		align-items: center;

		gap: 1rem;

		p {
			font-size: 1.5rem;
			font-weight: 400;
			font-family: "Mulish";

			color: #2d7bbc;
		}

		#svg-icon {
			width: 3rem;
			height: 3rem;

			color: #2d7bbc;
		}
	}

	
	@media (max-width: 1366px) {
		.process-wrapper {
			max-height: 550px;
		}
	}
`;
